import { Link } from 'react-router-dom';
import { articles } from '@/mocks/articles';

const articleImageUrls: Record<string, string> = {
  'kakobuy-sheet-kompletny-przewodnik': 'https://readdy.ai/api/search-image?query=Open%20laptop%20displaying%20organized%20product%20spreadsheet%20grid%20on%20warm%20oak%20desk%20with%20small%20succulent%20plant%20and%20coffee%20cup%20nearby%2C%20soft%20morning%20sunlight%20streaming%20through%20window%2C%20cozy%20minimalist%20home%20office%20aesthetic%2C%20warm%20neutral%20earth%20tones%20dominating%20the%20scene&width=900&height=400&seq=article-thumb-przewodnik-2026-unique&orientation=landscape',
  'najlepsze-produkty-kakobuy': 'https://readdy.ai/api/search-image?query=Overhead%20shot%20of%20carefully%20arranged%20fashionable%20clothing%20items%20including%20folded%20sweaters%20denim%20jeans%20sneakers%20and%20leather%20accessories%20on%20textured%20linen%20fabric%20surface%2C%20soft%20diffused%20natural%20light%2C%20editorial%20styling%20with%20warm%20beige%20and%20muted%20terracotta%20color%20palette%2C%20lifestyle%20photography%20composition&width=500&height=375&seq=article-thumb-produkty-2026-unique&orientation=landscape',
  'porownanie-spreadsheet-kakobuy-cssbuy': 'https://readdy.ai/api/search-image?query=Two%20modern%20smartphones%20placed%20side%20by%20side%20on%20marble%20surface%20showing%20different%20product%20listing%20interfaces%2C%20soft%20studio%20lighting%20with%20subtle%20shadows%2C%20clean%20minimalist%20tech%20review%20aesthetic%2C%20warm%20cream%20and%20light%20grey%20background%2C%20professional%20comparison%20photography%20style&width=500&height=375&seq=article-thumb-porownanie-2026-unique&orientation=landscape',
};

export default function ArticlesSection() {
  return (
    <section className="py-16 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col lg:flex-row lg:items-start lg:justify-between gap-4 mb-12">
          <div>
            <span className="inline-block px-4 py-1.5 rounded-full bg-accent-100 text-accent-700 text-xs font-semibold tracking-wider uppercase mb-4">
              Artykuły i poradniki
            </span>
            <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-foreground-900">
              Dowiedz się więcej
            </h2>
          </div>
          <p className="text-foreground-600 text-sm md:text-base max-w-md lg:text-right leading-relaxed">
            Praktyczne przewodniki, porównania i porady, które pomogą Ci w pełni wykorzystać możliwości arkuszy Kakobuy.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          {articles.map((article, index) => {
            const imageUrl = articleImageUrls[article.slug];
            const isWide = index === 0;

            return (
              <Link
                key={article.slug}
                to={`/artykul/${article.slug}`}
                className={`group block rounded-xl overflow-hidden bg-background-50 border border-background-200/60 hover:border-primary-300 transition-all duration-300 cursor-pointer ${
                  isWide ? 'md:col-span-2 md:row-span-1' : ''
                }`}
              >
                <div className={`relative overflow-hidden ${isWide ? 'aspect-[16/7]' : 'aspect-[4/3]'}`}>
                  <img
                    src={imageUrl}
                    alt={article.title}
                    className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                    loading="lazy"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-foreground-900/20 to-transparent"></div>
                </div>

                <div className={`p-5 ${isWide ? 'md:p-6' : ''}`}>
                  <h3 className={`font-heading font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors duration-200 leading-snug ${
                    isWide ? 'text-lg md:text-xl' : 'text-base'
                  }`}>
                    {article.title}
                  </h3>
                  <p className="text-foreground-500 text-sm mt-2 line-clamp-2 leading-relaxed">
                    {article.excerpt}
                  </p>
                  <div className="mt-4 inline-flex items-center gap-1.5 text-primary-500 text-sm font-medium">
                    <span>Czytaj więcej</span>
                    <i className="ri-arrow-right-line text-xs group-hover:translate-x-1 transition-transform duration-200"></i>
                  </div>
                </div>
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
}